export default {
    totalUniqueParts: 'Summe einzigartige Teile',
    totalParts: 'Summe Teile',
    totalRelevantParts: 'Summe lizenzrelevante Teile',
    partsQuota: 'Teile-Kontingent',
    partsQuotaLeft: 'Verfügbar',
    uniqueParts: 'Einzigartige Teile',
    used: 'Verbraucht',
    viewerLicenses: 'Viewer Lizenzen',
    editorLicenses: 'Editor Lizenzen',
    numberOfViewers: 'Anzahl der Viewer',
    numberOfEditors: 'Anzahl der Editoren',
}